import { theme } from "@utils";
import styled from "styled-components";

// Timesheets uses span (number) to filter by type of timesheet
// Overtime uses title (string) to filter by type of overtime (e.g. "有給休暇", "休日出勤", etc.)
interface Props {
  type: string;
  startDate?: string;
  endDate?: string;
  userId?: number;
  groupId?: number;
  status?: number;
  title?: string;
  span?: number | null;
}

export const AppExportCsv = (props: Props) => {
  const { type, startDate, endDate, userId, groupId, status, title, span } = props;
  const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');  // Remove trailing slashes
  const normalizedType = type.replace(/^\/+/, '');
  const queryString = new URLSearchParams({
    startDate: startDate ?? "",
    endDate: endDate ?? "",
    id: userId?.toString() ?? "",
    group_id: groupId?.toString() ?? "",
    status: (status as any)?.toString() ?? "",
    title: title ?? "",
    span: (span ?? "").toString(),
  }).toString();

  const exportUrl = `${apiUrl}/api/${normalizedType}Csv/export?${queryString}`;
  //console.log("Export URL:", exportUrl); 

  return (
    <a
      href={exportUrl}
      style={{ textDecoration: "none" }}
    >
      <PrimaryButton>
        <p className="text">CSV出力</p>
      </PrimaryButton>
    </a>
  );
};

const PrimaryButton = styled.div`
padding: 1rem 3rem;
border-radius: 50px;
font-weight: bold;
transition: all 0.3s;
width:15rem;
text-align : center;
font-size : 12px;
cursor: pointer;
background-color: ${theme.colors.orange};
color: ${theme.colors.white00};
height:4rem;

@media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            width:100%;
        }

&:hover {
  background-color: ${theme.colors.yellow08};
}
&:focus {
  outline: 2px solid ${theme.colors.lightgray09};
}

    // display: flex;
    // font-weight: 700;
    // border: 2px solid orange;
    // color: orange;
    // border-radius: 10px;
    // display: flex;
    // align-items: center;
    // width: fit-content;
    // padding: 8px 10px;
    // :hover {
    //     cursor: pointer;
    //     color: #d88d02;
    //     border: 2px solid #d88d02;
    //     .icon {
    //         fill: #d88d02;
    //     }
    // }
    // .icon {
    //     fill: orange;
    // }
    // .text {
    //     margin-left: 1rem;
    // }
`;
